import { makeVar } from '@apollo/client';

export const defaultExchangeRate = {
    exchangeRateId: null,
    exchangeRateDate: null,
    partnerId: null,
    bankName: null,
    refCurrencyId: null,
    refCurrencyCode: null,
    currencyId: null,
    currencyCode: null,
    exchangeRate1: null
  };

export const exchangeRateModalVar = makeVar({ open: false, item: defaultExchangeRate });
